import Utils from '../../app/utils/utils';

export const API_URL = process.env.REACT_APP_DISPATCH_API_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {token},
        cancelToken: { cancelToken }
      } = store.getState()

      if(cancelToken){
        config.cancelToken = cancelToken.token;
      }

      if (token) {
        // let currentValue = Utils.getCookie();
		    // let currentValue = Utils.getProjectVersion();
        // let isV4 = (currentValue == null || currentValue == 'v4');
        // let isDispatch = config?.url.includes(API_URL);
        // if(!isV4 && isDispatch){
        //   config.headers['x-api-version'] = API_VERSION
        // }

        let isDispatch = config?.url.includes(API_URL);
        const currentAddressBarUrl = window.location.href;
        const isV5 = currentAddressBarUrl.includes('/v5/');
        if (isV5 && isDispatch) {
          config.headers['x-api-version'] = API_VERSION
        }

        config.headers['content-type'] = 'application/json'
        config.headers.ContentType = 'application/json'
        config.headers.Authorization = (config && config.headers && config.headers.Authorization) ? config.headers.Authorization : token
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}
